import { Record as record } from 'immutable';
import { omit } from 'lodash';
import URI from 'urijs';

import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    origin: null,
    destination: null,
    errormsg: null,
    pagenotif: null,
    handoffid: null,
    hostname: null,
    referrer: null,
    value: null,
    orderid: null,
};

export default class Handoff extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(Handoff, json, {
            origin: fields.string,
            destination: fields.string,
            errormsg: fields.string,
            pagenotif: fields.string,
            handoffid: fields.string,
            hostname: fields.string,
            referrer: fields.string,
            value: fields.string,
            orderid: fields.number,
        });
    }

    getReferralQueryString () {
        return URI.buildQuery(omit(this.toJS(), 'orderid'), false);
    }

    getTransactionQueryString (orderid) {
        const params = {...omit(this.toJS(), 'errormsg', 'pagenotif'), orderid};
        return URI.buildQuery(params, false);
    }
}
